(function () {
  function utmSuffix() {
    var params = new URLSearchParams(window.location.search);
    var campaign = params.get('utm_campaign');
    var source = params.get('utm_source');
    var via = campaign || source;
    return via ? ' (vía ' + via + ')' : '';
  }

  function applyUtm() {
    var suffix = utmSuffix();
    if (!suffix) return;
    document.querySelectorAll('.anturia-oferta-whatsapp-link').forEach(function (el) {
      var base = el.getAttribute('data-wa-base');
      var number = el.getAttribute('data-wa-number');
      if (!base || !number) return;
      el.setAttribute('href', 'https://wa.me/' + number + '?text=' + encodeURIComponent(base + suffix));
    });
  }

  function watchSticky() {
    var sentinel = document.querySelector('[data-anturia-sentinel]');
    var sticky = document.querySelector('[data-anturia-sticky]');
    if (!sentinel || !sticky || typeof IntersectionObserver === 'undefined') return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    });
    observer.observe(sentinel);
  }

  function pauseAnnouncementBar() {
    var slideshow = document.querySelector('.announcement-bar-section slideshow-component');
    if (slideshow && typeof slideshow.pause === 'function') slideshow.pause();
  }

  applyUtm();
  watchSticky();
  pauseAnnouncementBar();
})();
